var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"next-step-button"},[_c('button',{staticClass:"next-step",on:{"click":_vm.nextStep}},[_vm._v(_vm._s(_vm.$t("המשך")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }